import React, {useContext, useEffect, useState} from "react";
import {
  CircularProgress, Stack,
} from "@mui/material";
import {Context as AppContext} from "../../context/AppContext";
import {ProjectRichTableView} from "./components/project-rich-table-view";
import ProjectsPageTour from "../../components/tour/ProjectsPageTour";

export const Projects = () => {
  const {getUserProjects, state: {projects}} = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [shouldRunTour, setShouldRunTour] = useState(() => {
    return sessionStorage.getItem("tour") === "true";
  });

  useEffect(() => {
    getUserProjects({setLoading})
  }, []);

  useEffect(() => {
    if (shouldRunTour) {
      sessionStorage.removeItem("tour");
    }
  }, [shouldRunTour]);

  const handleTourFinish = () => {
    sessionStorage.removeItem("tour");
    setShouldRunTour(false);
  };

  return (
      <>
        <ProjectsPageTour
          run={shouldRunTour && !loading}
          hasProjects={projects?.length > 0}
          onFinish={handleTourFinish}
        />
        <ProjectRichTableView/>
        {loading ? <Stack alignItems={"center"} justifyContent={"center"}><CircularProgress/></Stack> : null}
      </>
  )
}
